module.exports = __webpack_public_path__ + "static/img/co2.dcc5e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co2.jpg
// module id = wVwl
// module chunks = 11